import React from 'react';
import { howSteps } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function HowItWorks() {
  return <section className="bg-ivory px-4 py-14 md:py-20" data-id="element-109" data-mp="7u6lqrwqxqr1">
      <div className="mx-auto max-w-6xl" data-id="element-110" data-mp="3pz9tkke3kgv5">
        <Eyebrow data-id="element-111" data-mp="3q0b3umnagzbt">How it works</Eyebrow>
        <SectionTitle data-id="element-112" data-mp="3tztmtcvjv0c0">
          You don't have to build <Mark data-id="element-113" data-mp="3u0ljys4sp64e">every class from scratch.</Mark>
        </SectionTitle>

        <ol className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-114" data-mp="lk08n4ooy0y4">
          {howSteps.map(step => <li key={step.number} className="flex flex-col rounded-2xl border border-charcoal/10 bg-white p-6 shadow-sm" data-id="element-115" data-mp="qibktm2gknji">
              <span className="font-display text-4xl font-black leading-none text-gold-ink" data-id="element-116" data-mp="gtbj3uwkne1m">
                {step.number}
              </span>
              <h3 className="mt-3 font-display text-lg font-black uppercase leading-tight text-charcoal" data-id="element-117" data-mp="14iclb0et9syg">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-charcoal/75" data-id="element-118" data-mp="2rleh8fx6ps4u">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}